// External libraries
import gql from 'graphql-tag';

export const CONSUMER_FLOW_ID_QUERY = gql`
  query ConsumerFlowIdQuery($redirectUrl: String!) {
    consumerFlowId(redirectUrl: $redirectUrl) {
      flowId
    }
  }
`;
